module.exports = __webpack_public_path__ + "img/date.53e85217.svg";